/* @flow */
import { mutateAsync } from 'redux-query';

import * as q from './queries';
import * as t from './actionTypes';
import type { UseCase } from '../../data/TripRequests';

export function setNewFareEstimateUseCase(useCase: UseCase) {
  return {
    type: t.SET_NEW_FARE_ESTIMATE_USE_CASE,
    useCase,
  };
}

export function setNewFareEstimateOrginId(originId: string) {
  return {
    type: t.SET_NEW_FARE_ESTIMATE_ORIGIN_ID,
    originId,
  };
}

export function setNewFareEstimateDestinationId(destinationId: string) {
  return {
    type: t.SET_NEW_FARE_ESTIMATE_DESTINATION_ID,
    destinationId,
  };
}

export function createFareEstimateBatch(originId: string, destinationId: string, useCase?: string) {
  return mutateAsync(q.createFareEstimateBatch(originId, destinationId, useCase));
}



// WEBPACK FOOTER //
// ./src/redux/fare-estimates/actions.js